import React from 'react';
import { Box, Container, Stack, Text, Button, Alert, AlertIcon, useTheme } from '@chakra-ui/react';
import { CONTAINER_MAX_WIDTH_1 } from 'src/constants/ui';
import { MarketplaceInfo } from 'src/api/v1-api';
import { FREE_TIER_POSITION } from 'src/pages/_sites/[site]/admin/tier-options';
import { useRouter } from 'next/router';

interface Props {
  marketplace: MarketplaceInfo | null;
}

export const SampleListingsBanner = ({ marketplace }: Props) => {
  const theme = useTheme();
  const router = useRouter();

  if (!(marketplace?.tier?.position === FREE_TIER_POSITION && marketplace?.status === 'preview')) {
    return null;
  }

  return (
    <Box as="section" w="full">
      <Container maxW={CONTAINER_MAX_WIDTH_1} py={{ base: 2, md: 3 }}>
        <Alert
          status="info"
          borderRadius={theme.border_radius.border_radius_1}
          bg="lomaGreen.50"
          borderColor="lomaGreen.200"
          borderWidth="1px"
        >
          <AlertIcon color="lomaGreen.500" />
          <Stack
            spacing="2"
            justify={{ base: 'start', md: 'space-between' }}
            direction={{ base: 'column', md: 'row' }}
            align={{ base: 'start', md: 'center' }}
            w="full"
          >
            <Box>
              <Text fontWeight="medium" color="lomaGreen.900">
                Imported listings are for preview purposes at free tier
              </Text>
              <Text color="lomaGreen.700" fontSize="sm">
                Upgrade your plan before launching to keep your imported content
              </Text>
            </Box>
            <Button
              size="sm"
              onClick={() => router.push('/admin/tier-options')}
              flexShrink={0}
              border="1px solid"
              borderColor="lomaGreen.900"
              bg="white"
              color="lomaGreen.900"
              _hover={{
                bg: 'gray.50',
                textDecoration: 'none',
              }}
            >
              Upgrade Plan
            </Button>
          </Stack>
        </Alert>
      </Container>
    </Box>
  );
};

export default SampleListingsBanner;
